import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

const routes = apiRoutes.InsuranceManagement;

export const GetAllSupplyOrderShippingMethod = (payload: any) => {
  return HttpClient().post(
    `/${routes.GetAllSupplyOrderShippingMethod}`,
    payload
  );
};

export const GetShippingMethodLookup = () => {
  return HttpClient().get(`/${routes.GetShippingMethodLookup}`);
};

export const SaveSupplyOrderShippingMethod = (payload: {
  id: number;
  shippingMethod: string;
  shippingDays: string;
}) => {
  return HttpClient().post(`/${routes.SaveSupplyOrderShippingMethod}`, payload);
};

export const ChangeSupplyOrderShippingMethodStatus = (
  id: number,
  isDeleted: boolean
) => {
  return HttpClient().get(
    `/${routes.ChangeSupplyOrderShippingMethodStatus}/${id}/${isDeleted}`
  );
};

export const SaveSupplyOrderShippingMethodRules = (payload: {
  shippingMethodId: number;
  shippingMethodRules: Array<{
    id: number;
    expression: string;
    quantity: number;
    price: number;
  }>;
}) => {
  return HttpClient().post(
    `/${routes.SaveSupplyOrderShippingMethodRules}`,
    payload
  );
};

export const GetSupplyOrderShippingMethodRulesById = (id: number) => {
  return HttpClient().get(
    `/${routes.GetSupplyOrderShippingMethodRulesById}/${id}`
  );
};
